<template>
  <div>
    <v-card-title class="headline accent white--text">
      {{ $t('participant.resiliation.saisieMotifResiliation') }}
    </v-card-title>
    <v-card class="ma-5 pa-5">
      <enum-entity-field
        namespace="motifmouvement"
        :value="resiliationMotif"
        :searchActif="true"
        @input="$emit('input', $event)"
        i18n="participant.resiliation.motif"
      />
    </v-card>
    <v-card-actions>
      <v-btn
        @click="
          $emit('resilier')
          $router.go(-1)
        "
        color="error"
        :disabled="resiliationMotif === null"
      >
        {{ $t('button.resilier') }}</v-btn
      >
      <v-btn @click="$emit('close')">{{ $t('button.cancel') }}</v-btn>
    </v-card-actions>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'resiliationMotif',
    event: 'input',
  },
  props: {
    resiliationMotif: {
      type: Object,
    },
  },
}
</script>
